<template>
<div>
    <bar-manut
        single-entity="Perfil do Contador"
        plural-entity="Perfil do Contador"
        :crud="this.crud"
        :btn-delete="false"
        @closeform="closeForm"
        @save="handleSave">
    </bar-manut>
    
    <!-- ABAS DO FORMULÁRIO -->
    <tabs :tabs="tabs" :setActiveTab="activeTab" @onClickTab="changeTab" class="mb-4"></tabs>
    
    <div>
        <div class="default-container">
            <!-- MENSAGENS DE VALIDACAO -->
            <div v-if="(errmessages && errmessages.length) || errors.any()" class="alert alert-danger" role="alert">
                <div v-for="(msg, idx) in errmessages" :key="idx">{{ msg }}</div>
                <div v-for="error in errors.all()" :key="error">{{ error }}</div>
            </div>
            <!-- FIM MENSAGENS DE VALIDACAO -->

            <!-- ABA 1: USUÁRIO/LOGIN -->
            <div v-if="tabUsuario" data-vv-scope="usuario">
                <label-title title="Dados de Acesso do Usuário" icon=""></label-title>
                <div class="row">
                    <form-field ref="nome" v-model="usuario.nome" type="text" col="6" label="Nome do Usuário"
                        name="nome" :v-errors="errors" v-validate="{required: true, max: 60}"></form-field>
                </div>
                <div class="row">
                    <form-field v-model="usuario.email" type="email" col="6" label="Email de Login" :disabled="true"
                        name="email" :v-errors="errors" v-validate="{required: true, max: 255, email: true}"></form-field>
                </div>
                <div class="row">
                    <form-field v-model="usuario.fone" type="fone" col="3" label="Telefone de Contato"
                        name="fone" :v-errors="errors" v-validate="{max: 30}"></form-field>
                </div>

                <!-- SENHA -->
                <label-title class="mt-4" title="Alterar Senha" icon=""></label-title>
                <div class="row">
                    <form-field v-model="senha1" type="password" col="6" label="Nova Senha"
                        name="senha1" :v-errors="errors" v-validate="{max: 20}">
                        <span class="data-list w-100"><small>Defina a senha com no máximo 20 caracteres (deixe em branco para não alterar)</small></span>
                    </form-field>
                </div>
                <div class="row" v-if="senha1">
                    <form-field v-model="senha2" type="password" col="6" label="Repetir Nova Senha"
                        name="senha2" :v-errors="errors" v-validate="{required: true, max: 20}"></form-field>
                </div>
            </div>

            <!-- ABA 2: FILIAL/ESCRITÓRIO -->
            <div v-if="tabFilial" data-vv-scope="filial">
                <label-title title="Dados da Filial / Escritório de Contabilidade" icon=""></label-title>
                
                <div class="row">
                    <form-field ref="nomeFilial" v-model="filial.nome" type="text" col="6" label="Nome / Razão Social da Filial"
                      name="nome_filial" :v-errors="errors" v-validate="'required'"></form-field>
                </div>

                <div class="row">
                    <form-field v-model="filial.cep" type="cep" col="3" label="CEP" name="cep" id="cep"
                      :v-errors="errors" v-validate="'required'" @update="updateCep"></form-field>
                </div>
                
                <div class="row">
                    <form-field v-model="filial.ende" type="text" col="6" label="Endereço" name="ende" id="ende"
                      :v-errors="errors" v-validate="'required'"></form-field>
                    <form-field v-model="filial.endenr" type="text" col="2" label="Número" name="endenr" id="endenr"
                      :v-errors="errors" v-validate="'required'"></form-field>
                    <form-field v-model="filial.endecomp" type="text" col="4" label="Complemento" name="endecomp" id="endecomp"
                      :v-errors="errors"></form-field>
                </div>

                <div class="row">
                    <form-field v-model="filial.bairro" type="text" col="4" label="Bairro" name="bairro" id="bairro"
                      :v-errors="errors" v-validate="'required'"></form-field>
                    <form-field v-model="filial.uf" type="select2" col="4" label="Estado (UF)" name="uf" id="uf"
                      :v-errors="errors" v-validate="'required'"></form-field>
                    <form-field v-model="filial.codmun" type="select2" col="4" label="Cidade" name="codmun" id="codmun"
                      :v-errors="errors" v-validate="'required'"
                      :select2="{ entity: 'mun/uf/' + filial.uf, minlength: 2 }"></form-field>
                </div>

                <div class="row">
                    <form-field v-model="filial.fone1" type="fone" col="4" label="Telefone Comercial 1" name="fone1"
                      :v-errors="errors" v-validate="'required'"></form-field>
                    <form-field v-model="filial.fone2" type="fone" col="4" label="Telefone Comercial 2" name="fone2"
                      :v-errors="errors"></form-field>
                    <form-field v-model="filial.fone3" type="fone" col="4" label="Telefone Comercial 3" name="fone3"
                      :v-errors="errors"></form-field>
                </div>

                <div class="row">
                    <form-field v-model="filial.email" type="email" col="6" label="E-mail da Filial" name="filial_email"
                      :v-errors="errors" v-validate="'required|email'"></form-field>
                </div>

                <!-- LOGOTIPO -->
                <label-title class="mt-4" title="Logotipo da Filial" icon=""></label-title>
                <div class="row">
                    <div class="col-md-6 col-12">
                      <div v-if="filial.codfil" style="padding: 10px;">
                        <img v-if="image" :src="image" class="img-thumbnail d-block mb-2" alt="Logotipo"
                          style="max-width: 150px; max-height: 150px; cursor: pointer;"
                          @click="handleClickLogotipo()" />
                        <span v-if="image" class="data-list text-danger" style="cursor: pointer"
                          @click="apiDeleteImage"><small><i class="fa fa-trash" aria-hidden="true"></i> Remover Imagem</small></span>
                        
                        <i v-if="!image" class="fa fa-camera d-block mb-2" style="font-size: 72px; color: silver; cursor: pointer"
                          @click="handleClickLogotipo()"></i>
                        <span v-if="!image" class="data-list" style="cursor: pointer"
                          @click="handleClickLogotipo()">Selecionar Imagem</span>
                      </div>
                      <div class="row">
                        <input v-show="false" id="anexo" type="file" ref="file" accept="image/*"
                          @change="handleUpload($event)" />
                      </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>
</template>

<script>
import { SysVars } from '../main'
import axios from 'axios'
import { apiORDSapp, apiORDSmidia, apiORDSpost } from '../shared/api-functions'

export default {
    props: {
        index: '',
        crud: '',
    },
    data() {
        return {
            activeTab: 0,
            tabs: [
                { title: 'Usuário / Login', icon: '' },
                { title: 'Filial / Escritório de contabilidade', icon: '' }
            ],
            senha1: '',
            senha2: '',
            errmessages: [],
            codfil: null,
            image: null,
            selectedFile: null,
            usuario: {
                codusuario: null,
                nome: '',
                email: '',
                senha: '',
                stusuario: '',
                perfil: '',
            },
            filial: {
                codfil: null,
                nome: '',
                cnpj: '',
                cep: '',
                ende: '',
                endenr: '',
                endecomp: '',
                bairro: '',
                uf: '',
                codmun: '',
                fone1: '',
                fone2: '',
                fone3: '',
                email: '',
                stfilial: 'A',
                logotipo: []
            },
            metadata: {
                filial: this.$store.getters.getEntities.metadata ? this.$store.getters.getEntities.metadata.filial : {}
            }
        }
    },
    computed: {
        tabUsuario() {
            return this.activeTab === 0;
        },
        tabFilial() {
            return this.activeTab === 1;
        }
    },
    methods: {
        closeForm () {
            this.$emit('closeform')
        },
        changeTab(idx) {
            this.activeTab = idx;
            this.$validator.reset();
        },
        updateCep() {
            this.filial.ende = SysVars.endereco.logradouro;
            this.filial.bairro = SysVars.endereco.bairro;
            this.filial.codmun = SysVars.endereco.ibge;
            this.filial.uf = SysVars.endereco.uf;
        },
        async loadData() {
            // 1. Carrega dados do Usuário
            if (this.index) {
                await this.$store.dispatch('loadUsuario', { id: this.index });
                if (this.$store.getters.getUsuario) {
                    this.usuario = { ...this.$store.getters.getUsuario };
                    this.senha1 = '';
                    this.senha2 = '';
                }
            }

            // 2. Carrega dados da Filial
            await this.$store.dispatch('loadFilial', {});
            const filialList = this.$store.getters.getFilialList || [];
            if (filialList.length > 0) {
                this.codfil = filialList[0].codfil;
                await this.$store.dispatch('loadFilial', { id: this.codfil });
                if (this.$store.getters.getFilial) {
                    this.filial = { ...this.$store.getters.getFilial };
                    
                    // Parse JSON fields to prevent ORA-40587 on save
                    if (typeof this.filial.parametros === 'string' && this.filial.parametros) {
                        try {
                            this.filial.parametros = JSON.parse(this.filial.parametros);
                        } catch (e) {
                            this.filial.parametros = {};
                        }
                    } else if (!this.filial.parametros) {
                        this.filial.parametros = {};
                    }

                    if (typeof this.filial.parametrosloja === 'string' && this.filial.parametrosloja) {
                        try {
                            this.filial.parametrosloja = JSON.parse(this.filial.parametrosloja);
                        } catch (e) {
                            this.filial.parametrosloja = null;
                        }
                    }

                    this.loadLogotipo();
                }
            }
        },
        loadLogotipo() {
            if (!this.filial.codempresa) return;
            apiORDSmidia(
                this.$store.getters.urlApp +
                "logo/download/" +
                this.filial.codempresa +
                "/" +
                this.filial.codfil
            ).then(data => {
                if (data && data.size > 0) {
                    let self = this;
                    let reader = new window.FileReader();
                    reader.readAsDataURL(data);
                    reader.onload = function () {
                        self.image = reader.result;
                    };
                }
            });
        },
        handleClickLogotipo() {
            this.$refs.file.value = '';
            this.$refs.file.click();
        },
        handleUpload(event) {
            this.selectedFile = event.target.files[0];
            this.uploadImage();
        },
        uploadImage() {
            let formData = new FormData();
            formData.append("file", this.selectedFile);
            var url = this.$store.getters.urlApp + "logo/";
            var self = this;
            axios.post(url, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    codfilial: this.filial.codfil,
                    filename: this.selectedFile.name
                }
            }).then(function () {
                self.$erpToastSuccess("O logotipo foi atualizado com sucesso.");
                self.loadLogotipo();
            });
        },
        async apiDeleteImage() {
            if (!this.filial.logotipo || this.filial.logotipo.length == 0) return;
            var modulo = "logo/" + this.filial.logotipo[0].codlogotipo;
            await apiORDSapp(this, modulo, "delete");
            this.image = null;
            this.$erpToastSuccess("O logotipo foi removido com sucesso.");
        },
        handleSave() {
            if (this.senha1 && this.senha1 != this.senha2) {
                alert('As senhas não conferem')
                return
            }

            const scope = this.activeTab === 0 ? 'usuario' : 'filial';
            this.$validator.validateAll(scope).then(isValid => {
                if (!isValid) {
                    this.$erpToastError('Por favor, corrija os campos em destaque para continuar')
                } else {
                    this.apiPost()
                }
            })
        },
        async apiPost() {
            this.errmessages = [];

            // Salvar Usuário (core DB / urlApp)
            if (this.senha1) {
                this.usuario.senha = this.senha1;
            }
            var sendData = { usuario: this.usuario };
            const data = await apiORDSapp(this, 'usuario/', 'put', sendData);
            
            if (data.errmessages) {
                this.errmessages = data.errmessages;
                this.$erpToastError('Alguns erros precisam ser corrigidos.');
            } else {
                // Salvar Filial (tenant DB / urlOrds)
                if (this.filial.codfil) {
                    var modulo = "cg/filial/";
                    var filialSendData = { filial: this.filial };
                    const filialRes = await apiORDSpost(this.$store, modulo, filialSendData, "put");
                    if (filialRes && filialRes.errmessages) {
                        this.errmessages = filialRes.errmessages;
                        this.$erpToastError('Erro ao salvar os dados da filial.');
                        return;
                    }
                }
                this.$erpToastUpdated();
                this.closeForm();
            }
        }
    },
    created() {
        this.loadData();
    }
}
</script>



// WEBPACK FOOTER //
// src/forms/perfil-contador-form.vue